import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

/**
 * What a picker must see on an MPS line besides the name: how many packs (one scan picks the
 * whole line), which bag it goes in, any marking such as fridge or CD, and do-not-substitute.
 * Renders nothing for lines without these details.
 */
@Component({
  selector: 'app-med-badges',
  standalone: true,
  imports: [CommonModule],
  template: `
    <span class="med-badges" *ngIf="packs || bagId || marking || doNotSubstitute">
      <span class="med-badge med-badge--packs" data-badge="packs" *ngIf="packs">{{ packs }}</span>
      <span class="med-badge med-badge--bag" data-badge="bag" *ngIf="bagId">Bag {{ bagId }}</span>
      <span class="med-badge med-badge--marking" data-badge="marking" *ngIf="marking">{{ marking.toUpperCase() }}</span>
      <span class="med-badge med-badge--dns" data-badge="dns" *ngIf="doNotSubstitute">Do not substitute</span>
    </span>
  `,
  styles: [`
    .med-badges { display: inline-flex; flex-wrap: wrap; gap: 4px; margin-top: 4px; }
    .med-badge {
      display: inline-block; padding: 1px 7px; border-radius: 10px;
      font-size: 0.75rem; font-weight: 600; line-height: 1.5; white-space: nowrap;
      border: 1px solid transparent;
    }
    .med-badge--packs { background: #e7f1ff; color: #0b4a8b; border-color: #b6d4fe; }
    .med-badge--bag { background: #f1f3f5; color: #343a40; border-color: #ced4da; }
    .med-badge--marking { background: #fff3cd; color: #664d03; border-color: #ffe69c; }
    .med-badge--dns { background: #f8d7da; color: #842029; border-color: #f1aeb5; }
  `],
})
export class MedBadgesComponent {
  @Input() packSize?: number | null;
  @Input() fullPacks?: number | null;
  @Input() bagId?: string | null;
  @Input() marking?: string | null;
  @Input() doNotSubstitute?: boolean | null;

  get packs(): string | null {
    return this.fullPacks && this.packSize ? `${this.fullPacks} × ${this.packSize}` : null;
  }
}
